import React, { useState, Fragment } from "react";
import Row from "antd/es/row/index";
import Col from "antd/es/col/index";
import cloneDeep from "lodash.clonedeep";
import Blank from './Blank'
import Text from './Text'
import Icon from "antd/es/icon/index";
import { Badge } from 'antd';

export default function SentenceComponent(props) {
  const {
    sentence,
    onSetHanzi,
    onSetPinyin,
    onSetBlank,
    onRemove,
  } = props;

  const setBlank = (value, index) => {
    const tempSentence = cloneDeep(sentence)
    tempSentence.blank[index] = value
    onSetBlank(tempSentence.blank, index)
  }

  const setPinyin = (event, index) => {
    const tempSentence = cloneDeep(sentence)
    tempSentence.pinyin[index] = event.target.value
    onSetPinyin(tempSentence.pinyin)
  }

  const setHanzi = (event, index) => {
    const tempSentence = cloneDeep(sentence)
    tempSentence.hanzi[index] = event.target.value
    onSetHanzi(tempSentence.hanzi)
  }

  const remove = (event, index) => {
    // console.log(event.target.nodeName.toLowerCase() === "input")

    event.preventDefault()
    /* 
      This is to prevent confusing the remove icon with other elements
    */
    if (event.target.nodeName.toLocaleLowerCase() === 'path') onRemove(index)
  }

  return (
    <Fragment>
      <Row type="flex" style={{ flexWrap: 'nowrap' }}>
        {
          sentence.hanzi.map((hanzi, index) => {
            const pinyin = sentence.pinyin[index]
            const content = (hanzi === -1 && pinyin === -1) ?
              (<Fragment>
                <Blank
                  blank={sentence.blank[index]}
                  onChange={value => setBlank(value, index)} 
                />
              </Fragment>) :
              (<Fragment>
                <Text
                  onSetPinyin={event => setPinyin(event, index)}
                  onSetHanzi={event => setHanzi(event, index)}
                  pinyin={pinyin}
                  hanzi={hanzi}
                />
              </Fragment>)

            return (
              <Fragment key={index}>
                <Col style={{ marginRight: 12 }}>
                  <a href="#">
                    <Badge
                      onClick={(event)=>remove(event, index)}
                      count={<Icon type="close-circle" theme="twoTone" />}
                      style={{ cursor: 'pointer', zIndex: 1 }}
                    >
                      {content}
                    </Badge>
                  </a>
                </Col>
              </Fragment>
            )
          })
        }
      </Row>
    </Fragment>
  )
}
